import React from 'react';
import './Header.css';
import WhiteBlock from '../WhiteBlock/WhiteBlock.js';
const Header = () =>{
    return(
        <header>
            <div className="hero-imagePhoto"></div>
            <div className="hero-imageOpacity"></div>
            <div className="header-titile">
                <h1 className="header-title__upper">Park Linowy</h1>
                <hr/>
                <p className="header-title__lower">OŚRODKA SPORTU I REKREACJI W LUBAWIE</p>
            </div>
            <WhiteBlock positiont="br"/>
        </header>
    )
}

export default Header;